export const USER_BUY = 'USER_BUY'
export const USER_SELL = 'USER_SELL'